export default "__VITE_ASSET__c2913f76__"